// extracted by mini-css-extract-plugin
module.exports = {"leaderImage":"Leader_leaderImage__2c9i9","name":"Leader_name__3go2I","designation":"Leader_designation__1HG1z"};